module.exports = __webpack_public_path__ + "static/media/Options.5f806d68.svg";